import React from 'react';
import { cssMap } from '@compiled/react';

import type { AiSuggestionsRightRailEntryPoint } from '@atlaskit/editor-common/analytics';

import { fg } from '@confluence/feature-gating';

import { SuggestionsPanel } from './SuggestionsPanel.tsx';
import { SuggestionsFooter } from './SuggestionsFooter.tsx';

const styles = cssMap({
	layout: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		overflow: 'hidden',
	},
	panelSystem: {
		// PanelBody provides a relative positioning context instead of a fixed height.
		position: 'absolute',
		inset: 0,
	},
	content: {
		flex: '1 1 0%',
		minHeight: '0px',
		overflow: 'auto',
	},
});

export const SuggestionsPanelLayout = ({
	entryPoint,
}: {
	entryPoint?: AiSuggestionsRightRailEntryPoint;
}): React.JSX.Element => (
	<div
		css={[styles.layout, fg('ads-panel-system-confluence-object-sidebar') && styles.panelSystem]}
	>
		<div css={styles.content}>
			<SuggestionsPanel entryPoint={entryPoint} />
		</div>
		<SuggestionsFooter />
	</div>
);
